// extracted by mini-css-extract-plugin
export var button = "_gt-0";